import React from 'react';
import cn from 'classnames';
import BodyText from "../../Typography/texts/BodyText";
import FormLabel from "../../Typography/texts/FormLabel";
import Preamble from "../../Typography/texts/Preamble";
import ValidationIcon from '../ValidationIcon';
import styles from './Field.module.scss';
import getFieldValidationStatus from './helpers/getFieldValidationStatus';
const Field = ({ name, labelIcon, label, hint, shouldDisableValidation = false, shouldShowValidationIcon = true, isAdditionalTextLarge = false, disableLabel = false, error, inputID, className, value, render, isSelect = false, shouldHideTextAfterInput = false, handleDateFocus, required, labelSrOnly, errorTextClassName = '', }) => {
    const validationStatus = getFieldValidationStatus({
        value,
        errorMessage: error,
        shouldDisableValidation,
    });
    const shouldDisplayAsValid = validationStatus === 'valid';
    const shouldDisplayError = validationStatus === 'invalid';
    const renderTextAfterInput = () => {
        if (shouldHideTextAfterInput) {
            return null;
        }
        if (shouldDisplayError) {
            return error;
        }
        return hint;
    };
    return (React.createElement("div", { className: className },
        label && !disableLabel && (React.createElement("div", { className: cn(styles.labelWrapper, labelSrOnly && styles.srOnly) },
            React.createElement(FormLabel, { required: required, htmlFor: inputID || name, onClick: handleDateFocus }, label),
            labelIcon)),
        React.createElement("div", { className: cn(styles.childWrapper, shouldDisplayAsValid && styles.valid) },
            render({ validationStatus, shouldShowValidationIcon }),
            shouldShowValidationIcon && shouldDisplayAsValid && (React.createElement(ValidationIcon, { isSelect: isSelect, type: "checkmark" })),
            shouldShowValidationIcon && shouldDisplayError && (React.createElement(ValidationIcon, { isSelect: isSelect, type: "cross" }))),
        !isAdditionalTextLarge ? (React.createElement(React.Fragment, null, (!shouldDisableValidation || !!hint) && (React.createElement(BodyText, Object.assign({ className: cn(styles.underFieldText, shouldDisplayError && styles.errorText, errorTextClassName) }, (shouldDisplayError && { role: 'log' }), { Tag: "span", "aria-live": "polite" }), renderTextAfterInput())))) : (React.createElement(Preamble, Object.assign({ className: cn(styles.underFieldTextLarge, shouldDisplayError && styles.errorText) }, (shouldDisplayError && { role: 'log' }), { "aria-live": "polite" }), renderTextAfterInput()))));
};
export default Field;
//# sourceMappingURL=Field.js.map